import { render, staticRenderFns } from "./BoundingBoxRepresentation.vue?vue&type=template&id=7ffca4cc&"
import script from "./BoundingBoxRepresentation.vue?vue&type=script&lang=js&"
export * from "./BoundingBoxRepresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports